<template id="map-template">
  <div>
    <zj-layout-container>
      <zj-layout-main>
        <div class="map-root select-none">
          <MapView
            ref="regionMap"
            MapKey="FireMap"
            @layerButtonClick="layerButtonClick"
          ></MapView>
          <div class="right-side">
            <div class="right-side-wrapper">
              <div class="right-side-1">
                <div class="content-wrapper">
                  <EquipRightPanel
                    :deviceList="fireEquipmentList"
                    :logList="logList"
                    :equipmentList="equipmentList"
                  ></EquipRightPanel>
                </div>
              </div>
            </div>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
    <el-dialog
      class="map_popup_dialog"
      destroy-on-close="true"
      top="30vh"
      :visible.sync="isVideoMonitorDialogVisible"
      title="实时监控"
    >
      <flv-player-real-time
        class="videoBig-item"
        :cameraId="cameraId"
        :cameraName="cameraName"
        :autoplay="autoplay"
        :streamType="streamType"
        :cameraIsOnline="cameraIsOnline"
        viewMode="noclose"
      />
    </el-dialog>
  </div>
</template>

<script>
import { getEquipmentCode, listExtEquipment } from "@/api/src/equipment";
import { listWarnRecord } from "@/api/src/warnMessage";

export default {
  name: "FireView",
  componentName: "FireView",

  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {},
  data() {
    return {
      loading: false,

      //预警日志
      logList: [],
      //设备信息
      fireEquipmentList: [],
      isVideoMonitorDialogVisible: false,
      cameraId: "",
      cameraName: "",
      cameraIsOnline: true,
      equipmentList: [],
    };
  },
  methods: {
    layerButtonClick: function (data) {
      let e = data.e;
      switch (data.action) {
        case "videomonitor":
          this.getMonitor(e.data.channelNo);

          break;
        default:
          this.$message({ type: "warning", message: data.action + "未实现" });
          break;
      }
    },
    // 获取设备code
    init() {
      getEquipmentCode("fireEquipment").then((response) => {
        this.code = response.data;
        this.getList();
        this.getLogList();
      });
    },
    // 查询
    getList() {
      this.loading = true;

      listExtEquipment({ tag: this.code, size: 10000 }).then(
        (response) => {
          this.fireEquipmentList = [];
          let list = response.rows;
          this.equipmentList = list;
          this.total = response.total;
          //故障数
          let exceptionCount = list.filter(function (item) {
            return item.onlineStatus == 2 || item.onlineStatus == null;
          }).length;
          //在线数
          let onlineCount = list.filter(function (item) {
            return item.onlineStatus == 1;
          }).length;
          this.fireEquipmentList = [
            {
              Name: "火情监测设备",
              Count: this.total || 0,
            },
            {
              Name: "使用中",
              Count: onlineCount || 0,
            },
            {
              Name: "故障",
              Count: exceptionCount || 0,
            },
          ];

          this.loading = false;
        }
      );
    },
    getMonitor(channelNo) {
      listExtEquipment({ channelNo: channelNo, size: 10 }).then((response) => {
        let monitors = response.rows;
        if (monitors && monitors.length > 0) {
          this.cameraId = monitors[0].equipmentCode;
          this.cameraName = monitors[0].equipmentName;

          this.isVideoMonitorDialogVisible = true;
        } else {
          this.$message({
            message: "未找到关联监控设备",
            type: "warning",
          });
        }
      });
    },
    //获取报警日志
    getLogList() {
      listWarnRecord({ categoryCode: this.code, pageSize: 10000 }).then(
        (response) => {
          this.logList = response.rows;
        }
      );
    },
  },
  mounted() {
    this.init();
    this.logInfo.ActionName = "火情监测设备概览";
    this.logInfo.LogMessage = "火情监测设备概览";
    this.logInfo.ModuleName = "智能控制";
    this.logInfo.PageName = "火情监测设备概览页";
    this.addOperationLog();
  },
  beforeDestroy() {},
  destroyed() {},
  controller: "UI",
  action: "FireView",
};
</script>

<style scoped>
.zj-vehicleview-root {
  height: 100%;
  width: 100%;
  position: relative;
}
</style>
